/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import VideoBackground from "./Pages/VideoBackground";
import "./styles/global.css";
import { Routes } from "./routes";
import Header from "./Pages/Header";
import Footer from "./Pages/Footer";


function App() {

  return (
    <div className="global">
      <VideoBackground />
      <Header />
      <main className="main-content">
        <Routes />
      </main>
      <Footer />
    </div>
  );
}

export default App;